import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"


import { defineComponent, Ref, ref, onMounted } from 'vue';
import CwLogin from '../components/home/Login.vue';
import CwDetail from '../components/home/Detail.vue';
import CwSnackbar from '../components/_share/Snackbar.vue';
import CwConfirm from '../components/_share/Confirm.vue';
import CwConfirmFile from '../components/ConfirmFile.vue';
import { LoginResult } from '../models/api';
import api from '../apis/api';
import sessionStorage from '../repository/session-storage';
import stateLogin from '../store/state-login';

const __default__ = defineComponent({
  name: 'HomePage',
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

// const loginStatus = ref(stateLogin.loginStatus.value);
const confirmFile = ref();

const login = async (result: LoginResult) => {
  stateLogin.loginInitial(result);
  stateLogin.loginStatus.value = true;
};

const logout = () => {
  stateLogin.loginStatus.value = false;
};

onMounted(() => {
  const loginInfo: LoginResult | null = sessionStorage.getLoginInfo();
  if (loginInfo === null) return;

  api.init(loginInfo.token);

  login(loginInfo);
});


return (_ctx: any,_cache: any) => {
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_openBlock(), _createBlock(_component_v_layout, { "full-height": "" }, {
    default: _withCtx(() => [
      (!_unref(stateLogin).loginStatus.value)
        ? (_openBlock(), _createBlock(CwLogin, {
            key: 0,
            "login-callback": login
          }))
        : (_openBlock(), _createBlock(CwDetail, {
            key: 1,
            "logout-callback": logout
          })),
      _createVNode(CwSnackbar, { "global-component": "" }),
      _createVNode(CwConfirm, { "global-component": "" }),
      _createVNode(CwConfirmFile, {
        ref_key: "confirmFile",
        ref: confirmFile
      }, null, 512)
    ]),
    _: 1
  }))
}
}

})